import {Observable} from "rxjs";

export class ObservableWithLazyLatest {

    /*
     * Creates an Observable that will wait for both observables to emit before emitting the first result
     * and will then emit only when source emits after that point.
     * This is to solve an issue where if "source" emits and then the "withLatestFrom" emits, the observable
     * may not emit until "source" emits again
     */
    public static create<S, C>(source$: Observable<S>, latestFrom$: Observable<C>): Observable<[S, C]> {
        const firstSelectSource$ = source$.combineLatest(latestFrom$).first();
        const allOtherSelections$ = source$.skip(1).withLatestFrom(latestFrom$);
        return Observable.merge(firstSelectSource$, allOtherSelections$);
    }
}
